import { Link } from "react-router-dom";

import "./breadcrumbs.scss";

const Breadcrumbs = (props) => {
  const { clazz, data = [] } = props;
  return (
    <div className={`breadcrumbs p2${clazz ? ` ${clazz}` : null}`}>
      {data.map((item, idx) => (
        <Link key={idx + '_' + item.id} className={"breadcrumbs__link"} to={item.link} onClick={()=>item?.onClick()}>
          {item.title}
        </Link>
      ))}
    </div>
  );
};

export default Breadcrumbs;
